import { AlgoliaPlacesState, algoliaPlacesInitialState } from './State'

import {
  SET_SEARCH_TERM,
  SET_OPTIONS,
  SET_IS_LOADING,
  SET_IS_SELECTOR_OPEN,
  RESET,
  AlgoliaPlacesAction
} from './Actions'

function algoliaPlacesReducer(state: AlgoliaPlacesState, action: AlgoliaPlacesAction): AlgoliaPlacesState {
  switch (action.type) {
    case SET_SEARCH_TERM:
      return Object.assign({}, state, { searchTerm: action.payload, isLoading: true, options: [] })
    case SET_OPTIONS:
      return Object.assign({}, state, { options: action.payload })
    case SET_IS_LOADING:
      return Object.assign({}, state, { isLoading: action.payload })
    case SET_IS_SELECTOR_OPEN:
      return Object.assign({}, state, { isSelectorOpen: action.payload })
    case RESET:
      return algoliaPlacesInitialState
    default:
      return state
  }
}

export default algoliaPlacesReducer
